export default {
    state: {
        params: {
            source: process.env.VUE_APP_VICIDIAL_APISOURCE,
            user: process.env.VUE_APP_VICIDIAL_APIUSER,
            pass: process.env.VUE_APP_VICIDIAL_APIPASSWORD,
            function: 'external_hangup',
            value: 1
        },
        call_in_progress: localStorage.inicioGestion || false,
        external_pause: true,
        park_call: false,
    },
    getters: {
        external_pause: (state) => state.external_pause,
        park_call: (state) => state.park_call,
        call_in_progress: (state) => state.call_in_progress,
    },
    mutations: {
        SET_EXTERNAL_PAUSE: (state, payload) => state.external_pause = payload,
        SET_PARK_CALL: (state, payload) => state.park_call = payload,
        SET_CALL_IN_PROGRESS: (state, payload) => state.call_in_progress = payload,
    },
    actions: {
        colgarLlamada({state}) {
            this.state.vicidial_api.get('api.php?source='+
                state.params.source+
                '&user='+state.params.user+
                '&pass='+state.params.pass+
                '&agent_user='+this.state.user.user.vicidial_id+
                '&function=external_hangup&value=1')
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
        },
        tipificarLlamada({state, commit}, payload) {
            this.state.vicidial_api.get('api.php?source='+
                state.params.source+
                '&user='+state.params.user+
                '&pass='+state.params.pass+
                '&agent_user='+this.state.user.user.vicidial_id+
                '&function=external_status&value='+payload.value)
            .then(response => {
                console.log(response)
            })
            .catch(error => {

            })
        },
        pausarReanudarAgente({state, commit}) {
            let external_pause = state.external_pause?'RESUME':'PAUSE';
            this.dispatch('vicidial/refreshExternalPause', !state.external_pause)
            this.state.vicidial_api.get('api.php?source='+
                state.params.source+
                '&user='+state.params.user+
                '&pass='+state.params.pass+
                '&agent_user='+this.state.user.user.vicidial_id+
                '&function=external_pause&value='+external_pause)
            .then(response => {
                //console.log(response)
            })
            .catch(error => {
                //console.log(error)
            })
        },
        parkCall({state, commit}) {
            let park_call = state.park_call?'GRAB_CUSTOMER':'PARK_CUSTOMER';
            this.state.vicidial_api.get('api.php?source='+
                state.params.source+
                '&user='+state.params.user+
                '&pass='+state.params.pass+
                '&agent_user='+this.state.user.user.vicidial_id+
                '&function=park_call&value='+park_call)
            .then(response => {
                commit('SET_PARK_CALL', !state.park_call)
            })
            .catch(error => {
                //console.log(error)
            })
        },
        external_call({state, commit}, payload) {
            this.state.vicidial_api.get('api.php?source='+
                state.params.source+
                '&user='+state.params.user+
                '&pass='+state.params.pass+
                '&agent_user='+this.state.user.user.vicidial_id+
                '&function=external_dial&value='+payload.value+
                '&phone_code='+payload.phone_code+
                '&search=YES'+
                '&preview=NO'+
                '&focus=YES')
            .then(response => {
            })
            .catch(error => {
                //console.log(error)
            })
        },
        refreshExternalPause({commit}, payload) {
            commit('SET_EXTERNAL_PAUSE', payload);
        }
    }
}